"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignaExDirisAbilityHandler = exports.SignaExDirisActorAbilityFactory = exports.SignaExDirisAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Darkness_1 = require("../../core/effects/core/Darkness");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class SignaExDirisAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SignaExDiris;
        this.__typeName = "SignaExDiris";
    }
}
exports.SignaExDirisAbilityArgs = SignaExDirisAbilityArgs;
let SignaExDirisActorAbilityFactory = class SignaExDirisActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SignaExDiris", "AllEnemies", 6);
    }
};
SignaExDirisActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SignaExDiris")
], SignaExDirisActorAbilityFactory);
exports.SignaExDirisActorAbilityFactory = SignaExDirisActorAbilityFactory;
let SignaExDirisAbilityHandler = class SignaExDirisAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        sequence = sequence.pushSequence("parallel");
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        for (const enemy of enemies) {
            container.applyProjectileAttackWithDamage({
                abilityKey: ability.args.__typeName,
                attackType: "magic",
                sequence,
                attackerId: ability.invokerId,
                targetId: enemy,
                toApply: [
                    AbilityDamage_1.AbilityDamage.Focus("Death", 180)
                ],
                projectileType: "MagicBall",
                projectilePath: "line",
                onHit(sequence) {
                    container.applyDebuffs({
                        attackerId: ability.invokerId,
                        targetId: enemy,
                        effects: [
                            {
                                effect: new core_1.LinkedEffectsEffectArgs([
                                    new Darkness_1.DarknessEffectArgs(),
                                    new core_1.SignaExDirisEffectArgs(6)
                                ], true),
                                duration: Duration_1.Duration.Turns(5),
                            },
                        ],
                        onApplied(sequence) {
                            sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(enemy, "head"), "EngulfingDarkness"));
                        },
                        sequence
                    });
                }
            });
        }
    }
};
SignaExDirisAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SignaExDiris)
], SignaExDirisAbilityHandler);
exports.SignaExDirisAbilityHandler = SignaExDirisAbilityHandler;
